module.exports = __webpack_public_path__ + "static/media/unmuted-hover.a88491ec.svg";